import i18n from '@/i18n';

export default function validationEchecAffectation(messages) {
  if (!messages) {
    return '';
  }
  const messagesList = messages.split('###');

  const messageTraduit = [];
  messagesList.forEach(message => {
    if (message.indexOf('UNABLE_TO_AUTO_ASSIGN_QTY_SOLD_DIFFERENT_ASSIGNABLE_FACE') === 0) {
      const elements = message.split('|')[0].split('@');

      messageTraduit.push(i18n.t('listeDemande.tab.echec.venduDifferentFacesAffectables', {
        reseau: elements[1],
        nFacesAffectables: elements[2],
        nFacesVendues: elements[3],
      }));
    }
    if (message.indexOf('DEMANDE_LOGISTIQUE_MULTIP') === 0) {
      messageTraduit.push(i18n.t('listeDemande.tab.echec.demandeLogistiqueMulti'));
    }
    if (message.indexOf('DEMANDE_LOGISTIQUE_AFFICHAGE') === 0) {
      messageTraduit.push(i18n.t('listeDemande.tab.echec.demandeWithDisplay'));
    }
    if (message.indexOf('DEMANDE_LOGISTIQUE_PARTIELLE') === 0) {
      messageTraduit.push(i18n.t('listeDemande.tab.echec.demandeWithPartial'));
    }
  });
  return messageTraduit;
}
